import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  standalone: false,
  selector: 'pop-up-title',
  templateUrl: './pop-up-title.component.html',
  styleUrls: ['./pop-up-title.component.scss']
})
export class PopUpTitleComponent {
  @Input('xButton') xButton!: string
  @Output('xButtonClick') xButtonEmiter: EventEmitter<any> = new EventEmitter()

  constructor() {}

  emit(event:any) {
    return this.xButtonEmiter.emit(event)
  }
}
